import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const TextGroup = (props) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.creatingNewRules === true) {
      setValue("");
    } else {
      setValue(props.value);
    }
  }, [props.creatingNewRules]);

  useEffect(() => {
    if (!props.creatingNewRules) {
      setValue(props.value);
    }
  }, [props.value]);

  useEffect(() => {
    props.onChange(value);
  }, [value]);

  return (
    <div className="text-left">
      <Form.Label className="data-source-label">{props.text}</Form.Label>
      <Form.Control
        size='sm'
        placeholder={props.text}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type={props.type === 'number' ? 'number' : 'text'}
      />
      {/* <Form.Text className="font-italic" muted>
        {props.helperText}
      </Form.Text> */}
    </div>
  );
}

export default TextGroup
